import { TID } from "@/lib/testIds";

const CREDENTIALS = [
  "DPIIT Recognized Startup",
  "Advocates In-House",
  "MSMED Act Arbitration",
  "Make in Haryana Policy",
  "PADMA Cluster Scheme",
  "Atmanirbhar Textile Policy",
  "PMEGP · CGTMSE",
];

const CLIENTS = [
  "Mansarovar Industrial Park, Panipat",
  "Acres By Aura, Panipat",
  "Avani Infratech, New Delhi",
  "Seagull Buildwell, Sonipat",
  "NPL Buildcon, New Delhi",
  "Kuber Paper Pack, Sonipat",
  "Paliwal Group, Panipat",
];

const Row = ({ items, reverse = false, size = "lg" }) => {
  const track = [...items, ...items];
  return (
    <div className="overflow-hidden">
      <div
        className={`marquee-track ${reverse ? "marquee-reverse" : ""} ${
          size === "sm" ? "py-4" : "py-6"
        }`}
      >
        {track.map((t, i) => (
          <span
            key={i}
            className={`mx-8 md:mx-12 font-serif tracking-tight whitespace-nowrap ${
              size === "sm"
                ? "text-xl md:text-3xl text-white/75"
                : "text-3xl md:text-5xl text-white/90"
            }`}
          >
            {t}
            <span className="mx-8 md:mx-12 text-[color:var(--gold)]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export const Marquee = () => (
  <section
    data-testid={TID.marquee}
    className="relative bg-navy text-white border-y border-white/10 overflow-hidden"
  >
    <Row items={CREDENTIALS} size="lg" />
    <div className="border-t border-white/10">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 py-3 border-b border-white/10 flex items-center gap-3">
        <span className="h-1.5 w-1.5 bg-[color:var(--gold)]" />
        <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-white/60">
          Trusted by promoters & developers
        </span>
      </div>
      <Row items={CLIENTS} reverse size="sm" />
    </div>
  </section>
);

export default Marquee;
